import { useState } from 'react';

import { routeService } from '../../../../application/RouteService';
import { Route } from '../../../../domain/route/Route';
import { useErrorMiddleware } from '../../../../hooks/useErrorMiddleware';
import { useShowSnackbarMessage } from '../../../../hooks/useShowSnackbarMessage';

type UseRetrieveRouteRawResponseProps = {
  data: Route | null;
  run: (routeId: string) => void;
};

// Hooks act as 'Adapter' layer.
export const useRetrieveRouteRaw = (): UseRetrieveRouteRawResponseProps => {
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const [route, setRoute] = useState<Route | null>(null);

  const fetchRoute = async (routeId: string) => {
    try {
      const route = await routeService.fetchRoute({ routeId });
      setRoute(route);
    } catch (err: any) {
      console.info(`Retrieve Raw Route Error: `, err?.response);

      if (err?.response?.status === 401) {
        sessionExpiredLogout();
        return;
      }

      showSnackbarMessage({
        messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
      });
    }
  };

  return {
    data: route,
    run: fetchRoute,
  };
};
